import React, {Component} from 'react'
import { Redirect } from 'react-router-dom'
import * as config from '../Configuration/Config.js'
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,
  MdFolder,
  MdFolderOpen,
  MdInsertDriveFile
} from "react-icons/md";

//https://www.npmjs.com/package/react-checkbox-tree
//https://codesandbox.io/embed/silly-browser-81ff9

class Tree extends Component {

    constructor() {
        super();
        this.handleSave = this.handleSave.bind(this)

         this.state = {
            is_loaded: false, 
            checked: [],
            expanded: [],
            nodes: [],
            user_id: null,
            customer_id: null,
            user: null
        }
        
    }

    componentDidMount() {        
        const user_id = '1b6f2234-59ad-4eb8-96e2-fc0ac3a14f6c';
        const customer_id = 'eea3f92f-47f9-4d21-a136-9bec25f09db6';
        this.fetchTreeNode(user_id,customer_id)        
    }

    fetchTreeNode(user_id,customer_id) {
        var that = this;        
        
        let uri = config.getAcumenAPIURL('customer/' + customer_id + '/visuals');        
        let geturi = config.getAcumenAPIURL('api/user/visuals/' + user_id); 
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix()); 

        var user_checked = [];
        fetch(geturi, {
          method: 'get',
          headers: myHeaders
        }).then(function(response) {
          if (response.status >= 400) {
          throw new Error("Bad response from server");
          }
          return response.json();
      })
      .then(function(data) {                
          user_checked = data.visuals;
      });
        
        console.log(uri);
        fetch(uri, {
                method: 'get',
                headers: myHeaders
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function(data) {                
                that.setState({is_loaded: true, checked: user_checked,user_id: user_id, customer_id: customer_id, nodes:data.nodes});
            });
    }

    handleSave(event) {
        event.preventDefault();
        var that = this;
        var updatejson = {"user_id" : this.state.user_id, "customer_id" : this.state.customer_id, "visuals": this.state.checked}
        console.log('SAVE: '+  JSON.stringify(updatejson));   
    
        let uri = config.getAcumenAPIURL('api/user/visuals/' + this.state.user_id);        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix()); 

        fetch(uri, {
            method: 'post',
            headers: myHeaders,
            body: JSON.stringify(updatejson)
        }).then(function(response) {
            console.log(response.status);
            console.log(response.json());            
            if (response.status >= 400) {
              console.log(response);
              throw new Error("Bad response from server");
            }

            console.log('SAVED: '+  response);
        });
        
    }

    render() {
        if (this.state.is_loaded === false) {
            return <div>Loading...</div>
        }

        const icons = {
            check: <MdCheckBox className="rct-icon rct-icon-check" />,
            uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
            halfCheck: (
              <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
            ),
            expandClose: (
              <MdChevronRight className="rct-icon rct-icon-expand-close" />
            ),
            expandOpen: (
              <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />
            ),
            expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
            collapseAll: (
              <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
            ),
            parentClose: <MdFolder className="rct-icon rct-icon-parent-close" />,
            parentOpen: <MdFolderOpen className="rct-icon rct-icon-parent-open" />,
            leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />
          };
          console.log(this);

        return  <div className="grid-wrapper">
                    <div className="center-div">                           
                        <CheckboxTree
                            nodes={this.state.nodes}
                            checked={this.state.checked}
                            expanded={this.state.expanded}
                            onCheck={checked => this.setState({ checked })}
                            onExpand={expanded => this.setState({ expanded })}
                            icons={icons}
                        />
                    </div>
                    <div className="form-group">
                            <div className="centerAlign" colSpan="2">
                                <button onClick={this.handleSave} name="save" className="loginButton btn btn-primary">Save</button>                             
                            </div>
                        </div>
                </div>;
    }
}

export default Tree


// WEBPACK FOOTER //
// ./src/Components/tree/tree.js